import {
    stakeholderUpdateImage,
    stakeholderUpdateModel
} from "../../../actions/stakeholder-actions"
import buildItemConnector from "../../common/build-item-connector"

const mapDispatchToProps = dispatch => ({
    onStatusChange: ({ target: { name, checked } }) =>
        dispatch(stakeholderUpdateModel(name, checked ? "Active" : "Inactive"))
})

export default buildItemConnector(
    "stakeholders",
    false,
    stakeholderUpdateModel,
    stakeholderUpdateImage,
    undefined,
    null,
    mapDispatchToProps
)
